import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { Utility } from '../../../common/utility';
import { ConsultationUrl } from '../../../shared/urls/consultation.url';
import { InvoiceUrl } from '../../../shared/urls/invoice.url';
@Injectable()
export class ViewScheduleService {
    constructor(public baseService: BaseService) {
    }
    getVaccine(id) {
        const url = Utility.stringFormat(ConsultationUrl.GET_PRESCRIBE_VACCINATION, [id]);
        return this.baseService.getData(url, {isInvoiceSchedule : true});
    }

    updateInvoiceItem(consultationId, invoiceId, data: any) {
        const url = Utility.stringFormat(InvoiceUrl.ADD_INVOICE_ITEM, [consultationId, invoiceId]);
        return this.baseService.postData(url, data);
    }

    getTestOrdered(id) {
        let url = Utility.stringFormat(ConsultationUrl.GET_PATIENT_LABTEST, [id]);
        return this.baseService.getData(url);
    }
}

export const vaccine = [
    {
        vaccineName: 'Avaxim Hepatitis A Vaccine',
        vaccineId: '1',
        noOfAdminister: 3,
        currency: 1,
        vaccineDates: [
            {
                id: '1',
                visit: 0,
                isChecked: true,
                visitDate: '2017-09-10T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 20, //defaultCurrencyCode base on Centre
                isPaid: true
            },
            {
                id: '2',
                visit: 0,
                isChecked: true,
                visitDate: '2017-10-10T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 30, //defaultCurrencyCode base on Centre
                isPaid: true
            },
            {
                id: '3',
                visit: 1,
                isChecked: true,
                visitDate: '2017-11-16T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 30, // defaultCurrencyCode base on Centre
                isPaid: true
            },
            {
                id: '4',
                visit: 2,
                isChecked: true,
                visitDate: '2017-12-16T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 40, // defaultCurrencyCode base on Centre
                isPaid: true
            },
            {
                id: '5',
                visit: 2,
                isChecked: false,
                visitDate: '2017-12-18T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 50, // defaultCurrencyCode base on Centre
                isPaid: false
            },
        ],
    },
    {
        vaccineName: 'Avaxim Hepatitis A Vaccine ,Avaxim Hepatitis A Vaccine 2Avaxim Hepatitis A Vaccine 2',
        vaccineId: '2',
        noOfAdminister: 3,
        vaccineDates: [
            {
                id: '1',
                visit: 0,
                isChecked: true,
                visitDate: '2017-09-10T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 20, // defaultCurrencyCode base on Centre
                isPaid: true
            },
            {
                id: '2',
                visit: 0,
                isChecked: true,
                visitDate: '2017-10-10T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 20, //defaultCurrencyCode base on Centre
                isPaid: true
            },
            {
                id: '3',
                visit: 1,
                isChecked: true,
                visitDate: '2017-11-16T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 30, // defaultCurrencyCode base on Centre
                isPaid: true
            },
            {
                id: '4',
                visit: 2,
                isChecked: false,
                visitDate: '2017-12-16T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 40, // defaultCurrencyCode base on Centre
                isPaid: false
            },
            {
                id: '5',
                visit: 2,
                isChecked: false,
                visitDate: '2017-12-18T17:00:00',
                currencyRate: [
                    {
                        code: 'EUR',
                        symbol: '€',
                        symbolPosition: 'L',
                        rate: 1
                    },
                    {
                        code: 'GBP',
                        symbol: '£',
                        symbolPosition: 'R',
                        rate: 2
                    },
                    {
                        code: 'ZAR',
                        symbol: 'R',
                        symbolPosition: 'L',
                        rate: 3
                    }
                ],
                price: 40, // defaultCurrencyCode base on Centre
                isPaid: false
            },
        ],
    },
];

export const patientLabtest = [
    {
        id: '1',
        price: 40,
        isChecked: true,
        labTestId: '1',
        labTestName: 'eeeeP_A',

    },
    {
        id: '2',
        price: 50,
        isChecked: false,
        labTestId: '2',
        labTestName: 'eeeeP_B',

    },
    {
        id: '3',
        price: 30,
        isChecked: false,
        labTestId: '2',
        labTestName: 'eeeeP_C',

    },
    {
        id: '4',
        price: 20,
        isChecked: true,
        labTestId: '1',
        labTestName: 'eeeeP_D',

    },
    {
        id: '5',
        price: 40,
        isChecked: true,
        labTestId: '1',
        labTestName: 'eeeeP_E',
    },
];




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation/cash-sale/view-schedule-popup.service.ts